module.exports = __webpack_public_path__ + "static/media/choux.d1d1e2f9.svg";